/** @format */

import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "../../css/Report-TH.css";

import {
  GoogleMap,
  useJsApiLoader,
  Autocomplete,
} from "@react-google-maps/api";
import { MarkerF } from "@react-google-maps/api";

import { saveDataLatLon } from "../store/MapPositionSlice";

//////////////// Redux //////////////////
import { useSelector, useDispatch } from "react-redux";

const constants = require("file-configs/constants");

export default function CreateMap(props) {
  const globalData = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();

  const [map, setMap] = useState(null);
  const [searchResult, setSearchResult] = useState("");
  const [center, setCenter] = useState([]);

  const [markers, setMarkers] = useState([]);
  const mapRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: constants.GOOGLE_MAP_KEY,
    libraries: ["places"],
    region: "th",
    language: "th",
  });

  const containerStyle = {
    height: "250px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    borderRadius: "16px",
    filter: "drop-shadow(0px 1px 8px rgba(0, 0, 0, 0.1)) ",
  };
  const destinationRef = useRef();

  useEffect(() => {
    let coo;
    if (props.latPhoto) {
      coo = {
        lng: props.lngPhoto,
        lat: props.latPhoto,
      };

      if (Object.keys(coo).length !== 0 && isLoaded == true) {
        // setCenter([coo]);
        setMarkers([coo]);
        markers.push(coo);
      }
    }
  }, [props.latPhoto, props.lngPhoto, isLoaded]);

  useEffect(() => {
    if (
      Object.keys(globalData.mapPosition.current_coors).length !== 0 &&
      isLoaded == true
    ) {
      setCenter([globalData.mapPosition.current_coors]);
      setMarkers([globalData.mapPosition.current_coors]);
      markers.push(globalData.mapPosition.current_coors);
    } else {
    }
  }, [globalData.mapPosition.current_coors, isLoaded]);

  const handleMarkerMove = (event) => {
    setMarkers([{ lat: event.latLng.lat(), lng: event.latLng.lng() }]);
    dispatch(
      saveDataLatLon({ lng: event.latLng.lng(), lat: event.latLng.lat() })
    );

    map.panTo({ lat: event.latLng.lat(), lng: event.latLng.lng() });
  };

  const handleCenter = () => {
    if (!mapRef.current) return;

    const newPos = mapRef.current.getCenter().toJSON();
    setCenter(newPos);
  };

  const onLoad = React.useCallback(function callback(map) {
    map.setCenter({
      lat: globalData.mapPosition.current_coors.lat
        ? globalData.mapPosition.current_coors.lat
        : props.latPhoto,
      lng: globalData.mapPosition.current_coors.lng
        ? globalData.mapPosition.current_coors.lng
        : props.lngPhoto,
    });
    setMap(map);
  }, []);

  function onLoad2(autocomplete) {
    setSearchResult(autocomplete);
  }

  function onPlaceChanged() {
    if (searchResult != null) {
      //variable to store the result
      const place = searchResult.getPlace();

      setMarkers([
        {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
      ]);

      dispatch(
        saveDataLatLon({
          lng: place.geometry.location.lng(),
          lat: place.geometry.location.lat(),
        })
      );

      map.panTo({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });
    }
  }

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  return isLoaded == true && Object.keys(markers).length !== 0 ? (
    <div style={{ position: "relative", width: "100%" }}>
      {/* <Autocomplete onPlaceChanged={onPlaceChanged} onLoad={onLoad2}>
        <input
          id="searchAddressTextBox"
          ref={destinationRef}
          type="text"
          className="searchPlace"
          placeholder="ค้นหาสถานที่ (Type a location or click on the map)"
        />
      </Autocomplete> */}

      <GoogleMap
        onClick={handleMarkerMove}
        mapContainerStyle={containerStyle}
        onDragEnd={handleCenter}
        zoom={15}
        onLoad={onLoad}
        onUnmount={onUnmount}
        options={{
          zoomControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        }}>
        {markers.map((marker, index) => (
          <MarkerF position={marker}></MarkerF>
        ))}

        <></>
      </GoogleMap>
    </div>
  ) : (
    <></>
  );
}
